// Vuex connections module mutations

import {
  FILL_LIST,
  SET_FILTERING_CRITERIA,
  SET_PAGE,
  SET_CONNECTIONS_PER_PAGE,
  SET_SORTING_DIRECTION,
  FILL_HISTORY_LIST,
  CLEAR_HISTORY_LIST,
} from './mutations-types';

export default {
  [FILL_LIST](state, payload) {
    const _state = state;
    _state.list.records = payload.records;
    _state.list.total = payload.total;
  },
  [FILL_HISTORY_LIST](state, payload) {
    const _state = state;
    _state.historyList.records = payload.records;
    _state.historyList.total = payload.total;
  },
  [CLEAR_HISTORY_LIST](state) {
    const _state = state;
    _state.historyList.records = [];
    _state.historyList.total = 0;
  },
  [SET_FILTERING_CRITERIA](state, payload) {
    const _state = state;
    _state.filteringCriteria = payload;
  },
  [SET_PAGE](state, payload) {
    const _state = state;
    _state.list.page = payload.page;
  },
  [SET_CONNECTIONS_PER_PAGE](state, payload) {
    const _state = state;
    _state.connectionsPerPage = payload;
  },
  [SET_SORTING_DIRECTION](state, payload) {
    const _state = state;
    _state.sortingDirection = payload;
  },

};
